export const downloadFile = (fileUrl: string, fileName: string) => {
  const a = document.createElement("a");
  a.href = fileUrl;
  a.setAttribute("download", fileName);
  a.setAttribute("target", "_blank");
  a.click();
};
